
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["h-6 w-6",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg","class":"h-6 w-6"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"path-1-inside-1","fill":"#fff"}},[_c('rect',{attrs:{"x":"1","y":"12","width":"6","height":"11","rx":"1"}})]),_c('rect',{attrs:{"x":"1","y":"12","width":"6","height":"11","rx":"1","stroke":"#989AB3","stroke-width":"3.8","mask":"url(#path-1-inside-1)"}}),_c('mask',{attrs:{"id":"path-2-inside-2","fill":"#fff"}},[_c('rect',{attrs:{"x":"17","y":"4","width":"6","height":"19","rx":"1"}})]),_c('rect',{attrs:{"x":"17","y":"4","width":"6","height":"19","rx":"1","stroke":"#989AB3","stroke-width":"3.8","mask":"url(#path-2-inside-2)"}}),_c('mask',{attrs:{"id":"path-3-inside-3","fill":"#fff"}},[_c('rect',{attrs:{"x":"9","y":"8","width":"6","height":"15","rx":"1"}})]),_c('rect',{attrs:{"x":"9","y":"8","width":"6","height":"15","rx":"1","stroke":"#989AB3","stroke-width":"3.8","mask":"url(#path-3-inside-3)"}})])
          )
        }
      }
    